import {
  ICriterion,
  ICriterionData
} from '../../../abstract'
import {
  ICity,
  ICityData
} from './index'


export interface IPointData extends ICriterionData<string> {
  city?: ICityData,
  latitude?: number,
  longitude?: number
}

export interface IPoint extends IPointData, ICriterion<string> {
  city?: ICity

  path: string
  validate(): boolean
  update(data?: IPointData): void
}

export const POINT_NAME_MAX_LENGTH = 300
export const POINT_DESCRIPTION_MAX_LENGTH = 1000
